import React, { Component } from 'react'
import WindList from './WindList'
import AlertElement from './AlertElement'
import { useState, useEffect} from 'react';  
import SecurityComp from './SecurityComp';

import './App.css' 
import './style.min.css' 
import './LuckiestGuy-Regular.ttf'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Routes,
  Link,
  NavLink
} from "react-router-dom";
import crypto from 'crypto-js';

function App() {
    
    const cookies =  document.cookie.split(';').filter((x) => x.includes('password='))
    const pwV = cookies.length ? cookies[0].split("=")[1] : ''

    const [password, setPassword] = useState(pwV || '');
     
    const hash = crypto.SHA256(password);
    const unlocked = (crypto.SHA256(password).toString(crypto.enc.Hex) == 'ca4264faf5970fc613d80ad9e736f565d492e253a2faa84b35c8f2b2ef0be626')

    useEffect(() => {
      if (password)
        document.cookie = "password=" + password;
    }, [password]);

      return(
        <>
          <Router>
          <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
            integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3"
            crossorigin="anonymous"
          />
          <header className="topbar" data-navbarbg="skin5">
          <nav className="navbar top-navbar bg-dark navbar-expand navbar-dark">
              <div className="navbar-header" data-logobg="skin6">
                  <a className="navbar-brand" href="/">
                      <b className="logo-icon">
                      </b>
                      <span className="logo-text brand-text">
                        <b>Kite LIT</b>
                      </span>
                  </a>
                  <a className="nav-toggler waves-effect waves-light text-dark d-block d-md-none" href="javascript:void(0)"><i className="ti-menu ti-close"></i></a>
              </div>
              <div className="navbar-collapse collapse" id="navbarSupportedContent" data-navbarbg="skin5">
                 
                  <ul className="navbar-nav mr-auto ">

                      <li className="nav-item">
                      <NavLink className="nav-link" to="/" element={<AlertElement />}>
                        <b>Metrics</b>
                      </NavLink>
                      </li>
                  </ul>
              </div>
          </nav>
      </header>
          <div className="page-wrapper">
              <Routes>
                <Route 
                path="/" 
                element={unlocked ? <WindList /> : <SecurityComp password={password} onChange={(e) => setPassword(e.target.value) } />} />
                  
              </Routes>
          </div>
            </Router>
          }
        </>
      )   
}

export default App;
